export default class GiveAwaySeat {
    init() {
        $(document).ready(function () {
            if (window.location.pathname.indexOf('/Account/GiveAwaySeat') !== -1) {
                $('.tickets.modaltrigger').on('click', function (e) {
                    e.preventDefault();
                    var target = $(this).data('target');
                    if (target) {
                        $('#' + target).show();
                    }
                });
            }
        });
    }
}